<template>
  <b-spinner variant="primary" label="Loading" style="width: 3rem; height: 3rem;" ></b-spinner>
</template>

<script>

export default {
  name: 'loading_spinner'
}
</script>
